import { SectionHeader } from '~analytics-components/section-header';
import { SectionTiles } from '~analytics-components/section-tiles';
import { KpiCardFromSpec } from '../kpis/kpi-card-from-spec';
import type { KpiCardSpec } from '../kpis/card-spec';
import type { AnalyticsSectionProps } from './tabs';
import { FEATURED_CARDS, KEY_NUMBER_CARDS } from './cards';
import style from './style.module.scss';

export const OverviewSection = ({
    filter,
    onSelectTab,
}: Pick<AnalyticsSectionProps, 'filter' | 'onSelectTab'>) => {
    const renderCard = (spec: KpiCardSpec, index: number) => (
        <KpiCardFromSpec
            key={`${spec.source}-${spec.form}-${index}`}
            spec={spec}
            pageRange={filter.range}
            pageRegion={filter.provinces}
            compareEnabled={filter.compare}
            waveKey={filter.waveKey}
        />
    );

    return (
        <div className={style.dashboard}>
            <section className={style.section}>
                <SectionHeader
                    title="Featured"
                    subtitle="hero KPIs · at a glance"
                />
                <div className={style.dashboard_grid}>
                    {FEATURED_CARDS.map(renderCard)}
                </div>
            </section>

            <section className={style.section}>
                <SectionHeader title="Sections" subtitle="click to explore" />
                <SectionTiles onSelect={onSelectTab} />
            </section>

            <section className={style.section}>
                <SectionHeader
                    title="Key numbers"
                    subtitle="exploded charts worth seeing without a click"
                />
                <div className={style.dashboard_grid}>
                    {KEY_NUMBER_CARDS.map(renderCard)}
                </div>
            </section>
        </div>
    );
};
